import { featuresItems } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-600">为什么选择春夜影院？</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuresItems.map((item) => (
            <div key={item.id} className="group p-6 md:p-8 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 text-center">
              <span className={`inline-flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-2xl mb-5 ${
                item.id === "ft-1" ? "bg-primary-100 text-primary-600" :
                item.id === "ft-2" ? "bg-accent-100 text-accent-600" :
                item.id === "ft-3" ? "bg-secondary-100 text-secondary-700" :
                "bg-primary-100 text-primary-600"
              }`}>
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}